import {
    isSameWeek,
    isMonday,
    isTuesday,
    isWednesday,
    isThursday,
    isFriday,
    isSaturday,
    isSunday
} from 'date-fns';
import nl from 'date-fns/locale/nl';
document.addEventListener("DOMContentLoaded", function(event) {
    (function() {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
        {
            const warning = document.getElementById('browser-alert');
            if (warning) {
                warning.classList.add('show-me');
            }
        }
    })()
});

jQuery(document).ready(function ($) {

    /**
     * Monitor Gravity Forms part changes.
     */
    jQuery(document).on('gform_page_loaded', () => {
        trackWeekChanges(); // Start monitoring for week changes after Gravity Form page was changed.
        populateMenuForWeek(); // Populate (for Gravity Forms AJAX Submission compatibility).
        wrapSectionsFromPage(); // Wrap pages in content section for styling purposes
    });

    var weekNumberAndYear = $('#input_1_30').val();
    var menu;

    // Monitor week changes after pageload.
    trackWeekChanges();
    wrapSectionsFromPage();

    /**
     * This function tracks for changes in week selection.
     */
    function trackWeekChanges() {
        $('#input_1_30').on('change', function () {
            dropAllFromLocalStorageStartingWith('meal');
            dropAllFromLocalStorageStartingWith('soup');
            dropAllFromLocalStorageStartingWith('altpotato');
            dropAllFromLocalStorageStartingWith('altmeat');
            dropAllFromLocalStorageStartingWith('dessert');
            const _$ = $(this);
            weekNumberAndYear = this.value;
            const _ = _$.find('option:selected').text().split('(')[1].split(' ')[0];
            retrieveMenuForWeek(weekNumberAndYear);
            checkForClosedDays(_);
        });
    }

    /**
     * This function checks if the selected week has closed days.
     * It also disables these dates for ordering.
     *
     * @param {string} weekNumberAndYear [format dd-mm-yyyy]
     */
    function checkForClosedDays(weekNumberAndYear) {

        $('#choice_1_12_1').removeAttr('disabled').removeAttr('checked');
        $('#choice_1_12_2').removeAttr('disabled').removeAttr('checked');
        $('#choice_1_12_3').removeAttr('disabled').removeAttr('checked');
        $('#choice_1_12_4').removeAttr('disabled').removeAttr('checked');
        $('#choice_1_12_5').removeAttr('disabled').removeAttr('checked');
        $('#choice_1_12_6').removeAttr('disabled').removeAttr('checked');
        $('#choice_1_12_7').removeAttr('disabled').removeAttr('checked').trigger('change');

        const filteredArr = Array.from(localized.closed_days).filter(day => {
            const d = new Date(weekNumberAndYear.split('-')[2], Number(weekNumberAndYear.split('-')[1]) - 1, weekNumberAndYear.split('-')[0]);


            return isSameWeek(d, new Date(...[day.datum.split('/')[0], Number(day.datum.split('/')[1]) - 1, day.datum.split('/')[2]]));
        });

        document.body.addEventListener('wr-post-ajax-fetch',() => {
            filteredArr.forEach(day => {
                const jsFormattedDateUgh = new Date(...[day.datum.split('/')[0], Number(day.datum.split('/')[1]) - 1, day.datum.split('/')[2]]);

                if (isMonday(jsFormattedDateUgh)) {
                    $('#choice_1_12_1').attr('disabled', true);
                }
                if (isTuesday(jsFormattedDateUgh)) {
                    $('#choice_1_12_2').attr('disabled', true);
                }
                if (isWednesday(jsFormattedDateUgh)) {
                    $('#choice_1_12_3').attr('disabled', true);
                }
                if (isThursday(jsFormattedDateUgh)) {
                    $('#choice_1_12_4').attr('disabled', true);
                }
                if (isFriday(jsFormattedDateUgh)) {
                    $('#choice_1_12_5').attr('disabled', true);
                }
                if (isSaturday(jsFormattedDateUgh)) {
                    $('#choice_1_12_6').attr('disabled', true);
                }
                if (isSunday(jsFormattedDateUgh)) {
                    $('#choice_1_12_7').attr('disabled', true);
                }
            });
        }, { once: true });
    }

    function check(element) {

        $(element).attr('disabled', true);

    }

    /**
     * This function populates the menu's for the selected week.
     */
    function populateMenuForWeek() {
        document.body.dispatchEvent(new CustomEvent('wr-post-ajax-fetch'));

        let note = '';
        let weeknrtext = '<p>Het is momenteel <strong>week '+menu['currweek']+'</strong></p>';

        if (menu['overlap_allowed']) {
            if (jQuery.inArray( 'monday_overlap', menu['overlap_days'] ) > -1 ) {
                $('.gchoice_1_12_8').attr("style", "display: inline-block !important");
            }

            if (jQuery.inArray( 'tuesday_overlap', menu['overlap_days'] ) > -1 ) {
                $('.gchoice_1_12_9').attr("style", "display: inline-block !important");
            }
        } else {
            $('.gchoice_1_12_8').hide();
            $('.gchoice_1_12_9').hide();
        }

        if (menu['additional_note_week'] != undefined) {
            console.log(menu['additional_note_week']);
            note = '<p class="week_notice"><strong>Let op: </strong>'+menu['additional_note_week']+'</p>';
        }

        $('#gfield_description_1_30').html(weeknrtext+' '+note);

        $('.menu-form-meal-dropdown').each(function (i, obj) {

            $(obj).find('select:first').on('change', function () {
                window.localStorage.setItem(`meal-${$(this).attr('id')}`, $(this).val())
            });

            $(obj).find('select:first').find('option').remove();
            $(obj).find('select:first').append($("<option class='gf_placeholder' selected='selected' />").val('').text('Selecteer een maaltijd'));
            $.each(menu['menu'], function (index, val) {
                $(obj).find('select:first').append($("<option />").val(index).text(val));
            });

            $.each(menu['mealsoups'], function (index, val) {
                $(obj).find('select:first').append($("<option />").val(index).text(val));
            });

            if (window.localStorage.getItem(`meal-${$(obj).find('select:first').attr('id')}`)) {

                var n = window.localStorage.getItem(`meal-${$(obj).find('select:first').attr('id')}`);
                var options = Array.from($(obj)[0].querySelectorAll('option')).map(_ => _.value);

                if ($.inArray(n, options) > -1) {
                    $(obj).find('select:first').val(n);
                }
            }
        });

        $('.menu-form-soup-dropdown').each(function (i, obj) {

            $(obj).find('select:first').on('change', function () {
                window.localStorage.setItem(`soup-${$(this).attr('id')}`, $(this).val())
            });

            $(obj).find('select:first').find('option').remove();
            $(obj).find('select:first').append($("<option class='gf_placeholder' selected='selected' />").val('-').text('-'));
            $.each(menu['soup'], function (index, val) {
                $(obj).find('select:first').append($("<option />").val(index).text(val));
            });

            if (window.localStorage.getItem(`soup-${$(obj).find('select:first').attr('id')}`)) {

                var n = window.localStorage.getItem(`soup-${$(obj).find('select:first').attr('id')}`);
                var options = Array.from($(obj)[0].querySelectorAll('option')).map(_ => _.value);

                if ($.inArray(n, options) > -1) {
                    $(obj).find('select:first').val(n);
                }
            }
        });

        $('.menu-form-alt-potato-dropdown').each(function (i, obj) {

            $(obj).find('select:first').on('change', function () {
                window.localStorage.setItem(`altpotato-${$(this).attr('id')}`, $(this).val())
            });

            $(obj).find('select:first').find('option').remove();
            $(obj).find('select:first').append($("<option class='gf_placeholder' selected='selected' />").val('-').text('-'));
            $.each(menu['alt_potato'], function (index, val) {
                $(obj).find('select:first').append($("<option />").val(index).text(val));
            });

            if (window.localStorage.getItem(`altpotato-${$(obj).find('select:first').attr('id')}`)) {

                var n = window.localStorage.getItem(`altpotato-${$(obj).find('select:first').attr('id')}`);
                var options = Array.from($(obj)[0].querySelectorAll('option')).map(_ => _.value);

                if ($.inArray(n, options) > -1) {
                    $(obj).find('select:first').val(n);
                }
            }
        });

        $('.menu-form-alt-meat-dropdown').each(function (i, obj) {

            $(obj).find('select:first').on('change', function () {
                window.localStorage.setItem(`altmeat-${$(this).attr('id')}`, $(this).val())
            });

            $(obj).find('select:first').find('option').remove();
            $(obj).find('select:first').append($("<option class='gf_placeholder' selected='selected' />").val('-').text('-'));
            $.each(menu['alt_meat'], function (index, val) {
                $(obj).find('select:first').append($("<option />").val(index).text(val));
            });

            if (window.localStorage.getItem(`altmeat-${$(obj).find('select:first').attr('id')}`)) {

                var n = window.localStorage.getItem(`altmeat-${$(obj).find('select:first').attr('id')}`);
                var options = Array.from($(obj)[0].querySelectorAll('option')).map(_ => _.value);

                if ($.inArray(n, options) > -1) {
                    $(obj).find('select:first').val(n);
                }
            }
        });

        $('.menu-form-dessert-dropdown').each(function (i, obj) {

            $(obj).find('select:first').on('change', function () {
                window.localStorage.setItem(`dessert-${$(this).attr('id')}`, $(this).val())
            });

            $(obj).find('select:first').find('option').remove();
            $(obj).find('select:first').append($("<option class='gf_placeholder' selected='selected' />").val('-').text('-'));
            $.each(menu['dessert'], function (index, val) {
                $(obj).find('select:first').append($("<option />").val(index).text(val));
            });

            if (window.localStorage.getItem(`dessert-${$(obj).find('select:first').attr('id')}`)) {

                var n = window.localStorage.getItem(`dessert-${$(obj).find('select:first').attr('id')}`);
                var options = Array.from($(obj)[0].querySelectorAll('option')).map(_ => _.value);

                if ($.inArray(n, options) > -1) {
                    $(obj).find('select:first').val(n);
                }
            }
        });
    }

    /**
     * This function retrieves the menu for the selected week.
     *
     * @param weekNumberAndYear
     */
    function retrieveMenuForWeek(weekNumberAndYear) {
        jQuery.ajax({
            url: localized.ajax_url,
            type: 'post',
            data: {
                action: 'retrieve_menu_for_week',
                weekNumberAndYear: weekNumberAndYear
            },
            success: function (response) {
                menu = response;
                populateMenuForWeek();
            }
        });
    }

    /**
     *
     * @param {string} startsWith The string the keys should start with.
     */
    function dropAllFromLocalStorageStartingWith(startsWith) {
        const localKeys = Object.keys(window.localStorage);
        localKeys.forEach(key => {
            if (key.includes(startsWith)) {
                window.localStorage.removeItem(key);
            }
        })
    }

    function wrapSectionsFromPage() {

        const wrappablePages = document.querySelectorAll('.gform_page.wrap-sections');

        if (wrappablePages.length === 0) {
            return;
        }


        wrappablePages.forEach(page => {
            const fields = page.querySelectorAll('.gfield');
            let isStart = false;
            let tempArray = [];
            const fieldGroups = [];

            fields.forEach(field => {
                if (field.classList.contains('gsection')) {
                    if (!isStart) {
                        isStart = true;
                        tempArray = [];
                    }
                }

                tempArray.push(field);

                if (field.nextElementSibling?.classList.contains('gsection') ?? true) { // End of old list.
                    fieldGroups.push(tempArray);
                    isStart = false; // End of line for this section.
                }
            });

            if (fieldGroups.length === 0) {
                return;
            }

            const observer = new MutationObserver(function (mutations) {
                mutations.forEach(mutation => {
                    if (mutation.attributeName === 'style') {
                        if (mutation.target.style.display === 'none') {
                            mutation.target.parentElement.classList.add('hidden');
                        } else {
                            mutation.target.parentElement.classList.remove('hidden');
                        }
                    }
                });
            });

            fieldGroups.forEach(group => {

                if (group.length < 7) {
                    return;
                }

                const ul = document.createElement('ul');
                ul.className = 'styled-section';

                group.forEach(item => {
                    ul.append(item.cloneNode(true));
                    item.parentElement.removeChild(item);
                });

                observer.observe(ul.querySelector('.gsection'), {attributes: true,});

                page.querySelector('.gform_fields').insertBefore(ul, page.querySelector('.gform_fields .append-order-days-before'));
            });

            if (menu != undefined) {
                populateMenuForWeek();
            }
        })

    }

    if (typeof gform !== 'undefined') {
        gform.addFilter('gform_spinner_target_elem', function ($targetElem, formId) {
            return jQuery('.gform_title');
        });
    }


});